import { Col, Row } from 'antd';
import { Button, LayoutWithoutAuth } from 'components';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  confirmMobileSignature,
  initiateMobileSignature,
} from 'services/mobileSignatureService';
import './login.less';
import { customMessages } from 'utils';

const MobileSignature = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { gsmNumber } = useParams();
  const [currentScreen, setCurrentScreen] = useState('AgreementInfo');
  const [loadingMessage, setLoadingMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [contentVisible, setContentVisible] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const [fingerprint, setFingerprint] = useState(null);

  const initiate = () => {
    setCurrentScreen('UserConfirmation');
  };

  useEffect(() => {
    if (currentScreen === 'UserConfirmation') {
      setContentVisible(false);
      setErrorMessage('');
      setLoadingMessage(
        'Mobil imza işleminiz için operatörden cevap bekleniyor...'
      );

      initiateMobileSignature(gsmNumber)
        .then((response) => {
          handleInitiateResponse(response);
        })
        .catch((error) => {
          setLoadingMessage('');
          setErrorMessage(error.message || 'Mobil imza işlemi başlatılamadı.');
        });
    }
  }, [currentScreen, history, gsmNumber]);

  const handleInitiateResponse = (data) => {
    if (data.responseCode !== undefined) {
      setLoadingMessage('');
      setContentVisible(false);

      if (
        data.resultDescription.includes(
          'prepareFingerprint did not return a signToken'
        )
      ) {
        setErrorMessage(
          'Mobil imza işlemi başlatılamadı. Lütfen mobil imza servis aboneliğinizin aktif durumda olduğundan emin olunuz.'
        );
        return;
      }

      setErrorMessage(
        customMessages.getMessage(data.responseCode) ||
          'Mobil imza girişiniz tamamlanamadı. Lütfen mobil imza servis aboneliğinizin aktif durumda olduğundan emin olunuz.'
      );
      return;
    }

    setTransactionId(data.transaction_id || null);
    setFingerprint(data.fingerprint || null);
    setContentVisible(true);
    setLoadingMessage('Mobil imza işleminizi tamamlamanız bekleniyor...');
    confirmSignature(data.transaction_id);
  };

  const confirmSignature = async (transactionId) => {
    try {
      const response = await confirmMobileSignature(transactionId);
      if (response.responseCode === 200) {
        dispatch({
          type: 'LOGIN',
          payload: response,
        });
        setLoadingMessage(
          'Mobil imza işleminiz onaylandı! Yönlendiriliyorsunuz...'
        );
        setTimeout(() => {
          history.push({ pathname: '/Messages' });
        }, 2000);
      } else {
        setLoadingMessage('');
        setContentVisible(false);
        setTransactionId(null);
        setFingerprint(null);
        setErrorMessage(customMessages.getMessage(response.responseCode));
      }
    } catch (error) {
      setLoadingMessage('');
      setContentVisible(false);
      setTransactionId(null);
      setFingerprint(null);

      if (error.code === 'ECONNABORTED') {
        setErrorMessage('Bağlantı zaman aşımı. Lütfen tekrar deneyin.');
      } else {
        setErrorMessage(
          error.message || 'Mobil imza işlemi sırasında bir hata oluştu.'
        );
      }
    }
  };

  return (
    <LayoutWithoutAuth className="signup">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="signup-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Mobil İmza Doğrulaması</h1>
            </Col>

            {currentScreen === 'AgreementInfo' && (
              <>
                <Col
                  span={24}
                  className="flex-center-center margin-bottom-spacing-s"
                >
                  <p className="info-text">
                    Lütfen aşağıdaki sözleşme ve uyarıları okuyunuz, eğer
                    onaylıyorsanız "imzala" tușu ile devam ediniz.
                  </p>
                </Col>
                <Col span={24} style={{ marginBottom: '24px' }}>
                  <div
                    className="login-form-hint"
                    style={{
                      maxHeight: '240px',
                      overflowY: 'auto',
                      textAlign: 'left',
                      padding: '12px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                    }}
                  >
                    <p>
                      <strong>Mesaj Üssü</strong>'ne güvenli elektronik imza ile
                      yapılan girişlerde kimlik doğrulaması sağlanır ve
                      gerçekleştirilen işlemlerin ilgili kullanıcıya ait olduğu
                      kabul edilir.
                      <br />
                      <br />
                      <strong>Bilgi Teknolojileri ve İletişim Kurulu</strong>
                      'nun <strong>16.12.2025</strong> tarih ve{' '}
                      <strong>2025/DK-YED/399</strong> sayılı kararı kapsamında,
                      SMS ve MMS gibi mesaj gönderim kullanıcı arayüzlerine
                      göndericinin veya SMS ve MMS göndermeye yetkili kişinin
                      güvenli elektronik imza ile giriş yapması{' '}
                      <strong>1 Nisan 2026</strong> itibarıyla zorunlu
                      tutulmuştur.
                      <br />
                      <br />
                      <strong>Mesaj Üssü</strong> üzerinden gerçekleştireceğim
                      işlemlere ilişkin her türlü mali, idari, cezai ve hukuki
                      sorumluluğun tarafıma ait olduğunu; bu işlemlerle ilgili
                      hangi nam altında olursa olsun{' '}
                      <strong>Turkcell İletişim Hizmetleri A.Ş.</strong>'ye
                      karşı hiçbir talep veya iddiada bulunmayacağımı ve
                      Turkcell'in söz konusu işlemlerden doğabilecek zararlardan
                      herhangi bir sorumluluğu bulunmadığını kabul, beyan ve
                      taahhüt ederim.
                    </p>
                  </div>
                </Col>
              </>
            )}

            {currentScreen === 'UserConfirmation' && (
              <>
                {contentVisible && (
                  <>
                    <Col
                      span={24}
                      className="flex-center-center margin-bottom-spacing-s"
                    >
                      <p className="info-text">
                        Mobil imza isteğiniz başarıyla işleme alınmıştır.
                        Birazdan telefonunuzun ekranında mobil imza uyarısı
                        çıkacak ve işleminize ait parmak izi görüntülenecektir.
                        Telefonunuzda görüntülenen parmak izi, bu sayfada
                        gördüğünüz ile aynı olmalıdır. Mobil imza şifrenizi
                        girerek işleminizi tamamladıktan birkaç saniye sonra,
                        sisteme giriş yapmış olarak ana sayfa'ya
                        yönlendirileceksiniz.
                      </p>
                    </Col>
                    <Col span={24} style={{ marginBottom: '24px' }}>
                      <div style={{ textAlign: 'center' }}>
                        <h4
                          style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            marginBottom: '16px',
                            color: '#333',
                          }}
                        >
                          İşlemin Parmak izi:
                        </h4>
                        <div
                          style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px',
                            padding: '16px',
                            marginBottom: '16px',
                            fontFamily: 'monospace',
                            fontSize: '14px',
                            fontWeight: 500,
                            letterSpacing: '2px',
                            color: '#333',
                          }}
                        >
                          {fingerprint}
                        </div>
                        <p
                          style={{
                            fontSize: '13px',
                            marginBottom: '24px',
                            color: '#666',
                          }}
                        >
                          Kimliğinizin doğrulanması için biometrik verileriniz
                          kullanılacaktır.
                        </p>
                      </div>
                    </Col>
                  </>
                )}

                {loadingMessage && (
                  <Col span={24} style={{ marginBottom: '24px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '12px',
                        }}
                      >
                        <div
                          style={{
                            display: 'inline-block',
                            width: '36px',
                            height: '36px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #3fb0e8',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            flexShrink: 0,
                          }}
                        />
                        <p
                          style={{ fontSize: '14px', color: '#666', margin: 0 }}
                        >
                          {loadingMessage}
                        </p>
                      </div>
                    </div>

                    <style>{`
                    @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                    }
                  `}</style>
                  </Col>
                )}

                {errorMessage && (
                  <Col span={24} style={{ marginBottom: '24px' }}>
                    <div
                      style={{
                        backgroundColor: '#ffe6e6',
                        border: '1px solid #ffcccc',
                        borderRadius: '4px',
                        padding: '16px',
                        textAlign: 'center',
                      }}
                    >
                      <p style={{ color: '#cc0000', margin: 0 }}>
                        {errorMessage}
                      </p>
                    </div>
                  </Col>
                )}
              </>
            )}

            <Col span={24}>
              <Row justify="center" gutter={28}>
                {currentScreen === 'AgreementInfo' && (
                  <>
                    <Col xs={9} sm={12}>
                      <Button
                        type="ghost"
                        shape="round"
                        onClick={() => history.push('/Login')}
                      >
                        Geri
                      </Button>
                    </Col>
                    <Col xs={15} sm={12}>
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => initiate()}
                      >
                        İmzala
                      </Button>
                    </Col>
                  </>
                )}
                {currentScreen === 'UserConfirmation' && (
                  <Col xs={15} sm={12}>
                    <Button
                      type="ghost"
                      shape="round"
                      onClick={() => history.push('/Login')}
                      block
                    >
                      Kapat
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};

export default MobileSignature;
